
function loadFont(name, fileName) {
  const font = new FontFace(name, "url(/fonts/"+fileName+".ttf)");
  if (!document.fonts.has(font)) {
    document.fonts.add(font);
    font.load();
  }
}


const configureFonts = (res) => {
  let payload = res.payload;
  console.log("configureFonts", payload)
  if (Array.isArray(payload) && payload.length>0) {
    payload = payload.filter(f=>f.name.indexOf("Bold")<0);
    let css="";
    for (const font of payload) {
      font.cleanName = font.name.replace(/ /g,"");
      loadFont(font.name, font.file);
      css+=`.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${font.cleanName}"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${font.cleanName}"]::before{
font-family: "${font.name}", sans-serif;
content: "${font.name}";
}
.ql-font-${font.cleanName} {
font-family: "${font.name}", sans-serif;
}
`
    }
    let style = document.getElementById("wwFontsCss");
    if (!style) {
      style = document.createElement('style');
      style.id = "wwFontsCss";
    }
    style.innerHTML = css;
    document.head.appendChild(style);
    return payload;
  }
  return [];
}

export { configureFonts } ;
